<template lang="pug">
v-container(class=" pa-0 ma-0 tw-bg-gray-lighten-4 tw-w-full tw-h-full tw-overflow-hidden theme-f-listing-card-container  ")
  router-link(class="tw-font-medium tw-w-full tw-h-full" :to="{ path: '/website/listing/' + this.$faker().datatype.number() }")
    v-row(no-gutters class="" style="height: 200px")
      v-col(class=" tw-h-full")
        div(class="tw-relative tw-w-full tw-h-full tw-overflow-hidden  tw-border-gray-lighten-3  ")
          div(class="tw-absolute tw-top-0 tw-right-0 tw-z-30")
            v-chip(color="cyan darken-3" pill text-color="white" class="tw-m-3 tw-py-4")
              span(class=" tw-uppercase tw-font-bold") Rent
          div(
            class=" tw-absolute tw-z-10 tw-h-full tw-w-full tw-bg-gradient-to-b tw-from-gray-lighten-1 tw-to-teal-darken-4 tw-rounded"
          )
            v-img(
              :src="image"
              aspect-ratio="2"
              cover
              class="tw-h-full tw-w-full tw-opacity-75 tw-transform tw-transition-transform tw-duration-700 hover:tw-scale-110 "
            )
    v-row(no-gutters)
      v-col
        v-row(dense class="tw-relative tw-z-20 tw-text-black")
          v-col(cols="12" class=" tw-rounded tw-overflow-hidden  tw-h-auto")
            div(class="  tw-overflow-hidden tw-rounded-md  tw-m-4")
              v-row(no-gutters class=" tw-p-0")
                v-col(shrink)
                  v-row(no-gutters class="")
                    v-col(class="tw-m-3 tw-mt-1 tw-ml-2")
                      v-row(no-gutters align="center" justify="space-between")
                        v-col(cols="12" class="")
                          v-row(no-gutters align="center" justify="space-between")
                            v-col(cols="auto")
                              div(class="  tw-pt-1 tw-text-2xl tw-text-left  ")
                                router-link(
                                  :to="{ path: `Listing/${this.$faker().datatype.number()}` }"
                                  class="tw-font-bold  tw-whitespace-no-wrap"
                                )
                                  span(class="tw-text-cyan-darken-3") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
                  v-row(no-gutters class="tw-px-2")
                    v-col(cols="12")
                      div(class="tw-text-xl  tw-font-bold tw-text-left")
                        span(class="") {{ this.$faker().lorem.sentence(3) }}
                  v-row(no-gutters justify="space-between" align="center" class="tw-pl-1 mt-1")
                    v-col(cols="auto")
                      v-row(no-gutters align="center" justify="center")
                        v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                          div(class="tw-w-6 tw-h-6 tw-flex ")
                            v-icon(color="" class="tw-mx-auto") mdi-map-marker-outline
                        v-col(cols="auto" class=" tw-text-center")
                          span(class="tw-ml-1 ") {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
                  v-divider(class="my-2")
                  v-row(no-gutters justify="start" align="center" class="tw-px-2 ")
                    v-col(cols="auto" class=" tw-items-center tw-mb-2  ")
                      v-row(dense justify="center" class="tw-pt-2 tw-pb-0")
                        v-col(cols="auto" class="tw-mr-2")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              v-icon(color="grey darken-3") mdi-bed-outline
                              span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Beds

                        v-col(cols="auto" class="tw-mr-2")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              v-icon(color="grey darken-3") mdi-bathtub-outline
                              span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Bath

                        v-col(cols="auto" class="tw-mr-2")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              v-icon(color="grey darken-3") mdi-select-multiple
                              span(class="tw-ml-1 tw-text-sm") {{ this.$faker().datatype.number({ min: 200, max: 800 }) }} m <sup>2</sup>
</template>
<script>
export default {
  data() {
    return {
      image: null,
    };
  },
  mounted() {
    const img = new Image();
    img.src = 'https://picsum.photos/seed/' + this.$faker().datatype.number(5) + '/650/450';
    this.image = img.src;
  },
};
</script>
<style lang="scss">
.theme-f-listing-card-container {
  border-radius: 20px;
}
</style>
